import Link from 'next/link';
import { MenuIcon } from 'lucide-react';
import classNames from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import Logo from '../../Logo';
import LogoMobile from '../../LogoMobile';
import Cart from './Cart';
import Account from './Account';
import Help from './Help';
import DeliverTo from './DeliverTo';
import SearchInput from '../Search/SearchInput';
import StoreSelector from './StoreSelector';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const MenuButton = ({
  className,
  setShowMainMenu,
}: {
  className?: string;
  setShowMainMenu: Dispatch<SetStateAction<boolean>>;
}) => (
  <button
    className={classNames('outline-none', className)}
    onClick={() => setShowMainMenu((prev) => !prev)}
    aria-label={t`Open menu`}
  >
    <MenuIcon className="h-6 w-6 transition duration-100 ease-in-out hover:scale-105" />
  </button>
);

const TopNavbar = ({
  setShowMainMenu,
}: {
  setShowMainMenu: Dispatch<SetStateAction<boolean>>;
}) => (
  <div className="reebelo-container grid grid-cols-3 items-center gap-4 py-3 sm:flex sm:justify-between sm:py-2">
    <MenuButton setShowMainMenu={setShowMainMenu} className="sm:hidden" />
    <div className="flex w-full items-center justify-center gap-4 sm:justify-start">
      <div className="flex items-center gap-2">
        <MenuButton
          setShowMainMenu={setShowMainMenu}
          className="hidden sm:block lg:hidden"
        />
        <Link href="/" aria-label={t`Reebelo home`} className="outline-none">
          <Logo className="hidden lg:block" />
          <LogoMobile className="lg:hidden" />
        </Link>
      </div>
      <SearchInput className="hidden w-full max-w-[520px] sm:flex" />
    </div>
    <div className="flex shrink-0 items-center justify-end gap-6">
      <StoreSelector />
      <DeliverTo hideMenu={false} />
      <Help />
      <Account />
      <Cart />
    </div>
  </div>
);

export default TopNavbar;
